export const setNumeroProcessoAction = numeroProcesso => ({
  type: 'SET_NUMERO_PROCESSO',
  numeroProcesso
});
